import { actionTypes as tag } from '../reducers/tag';
import { actionTypes as teaser } from '../reducers/teaser';
import { actionTypes as filter } from '../reducers/filter';
import { actionTypes as system } from '../reducers/system';
import { actionTypes as person } from '../reducers/person';

export const actionTypes = {
	tag,
	filter,
	teaser,
	system,
	person
};



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js